import LocationAdapter from './location_adapter';
import URLUtils from '@javascripts/utils/url_utils';

export default class PubmaticAdapterV2 {
  static appendOpenWrapTargeting(tag, adUnit, adSize, callback){
    const pubmaticUrl = PubmaticAdapterV2.getPubmaticURL(adUnit, adSize);

    const xhr = new XMLHttpRequest();
    xhr.timeout = 1000;
    xhr.withCredentials = true;
    xhr.open("GET", pubmaticUrl);
    xhr.onload = function() {
      let appendedTag = tag;
      if(xhr.status == 200) {
        appendedTag = PubmaticAdapterV2.openWrapRequestSuccess(tag, xhr.response);
      }

      callback(appendedTag);
    }.bind(this);

    xhr.ontimeout = function() {
      callback(tag);
    }

    xhr.onerror = function() {
      callback(tag);
    }

    xhr.send();
  }

  static getPubmaticURL(adUnit, adSize) {
    const currentLocation = LocationAdapter.href();
    if(currentLocation.includes("localhost") || currentLocation.includes("127.0.0.1")) {
      return "http://localhost:9898/ads_params/pubmatic/1"
    }
    else {
      const encodedAdUnit = encodeURIComponent(adUnit);
      const encodedLocation = encodeURIComponent(currentLocation);
      const url = "https://ow.pubmatic.com/video/json";
      const owUrl = new URL(url);
      let params = "";

      // refer to this document for these parameters https://docs.google.com/spreadsheets/d/1gpaGyyorUAjubpmlpGm7qrUVDLsXSs_b6mRtPaeuleo/edit?usp=drive_web&ouid=102762846474233040381
      params = params + "site.pub.id=159568";
      params = params + "&site.page=" + encodedLocation;
      params = params + "&req.ext.wrapper.profileid=2803";
      params = params + "&imp.tagid=" + encodedAdUnit;
      params = params + "&imp.vid.mimes=video%2Fmp4,application%2Fjavascript";
      params = params + "&imp.vid.api=2,7";
      params = params + "&imp.vid.w=" + adSize.split('x')[0];
      params = params + "&imp.vid.h=" + adSize.split('x')[1];
      params = params + "&imp.vid.linearity=1";
      params = params + "&imp.vid.minbitrate=400";
      params = params + "&imp.vid.maxbitrate=3000";
      params = params + "&imp.vid.minduration=6";
      params = params + "&imp.vid.maxduration=60";
      params = params + "&imp.vid.playbackmethod=2";
      params = params + "&imp.vid.protocols=2,3,5,6,7,8";
      params = params + "&imp.vid.skip=1";
      params = params + "&imp.vid.skipmin=10";
      params = params + "&imp.vid.skipafter=5";
      params = params + "&imp.vid.startdelay=0";
      params = params + "&dev.lmt=0";
      params = params + "&dev.dnt=0";

      params = params + "&imp.vid.ext.adpod.admaxduration=60";
      params = params + "&imp.vid.ext.adpod.adminduration=6";
      params = params + "&imp.vid.ext.adpod.maxads=4";

      if(window.kmklabs && window.kmklabs.ads) {
        const genre = window.kmklabs.ads.genre;
        let title = window.kmklabs.ads.film_name + " " + window.kmklabs.ads.title;
        title = title.trim();

        params = params + "&site.cnt.genre=" + genre;
        params = params + "&site.cnt.title=" + encodeURIComponent(title);
      }

      owUrl.search = params;

      return owUrl.toString();
    }
  }

  static openWrapRequestSuccess(tag, response) {
    let appendedTag = tag;
    try {
      const jsonResponse = JSON.parse(response);

      if(jsonResponse.adpods) {
        let custParams = URLUtils.getQueryParam(tag, "cust_params");
        let parsingResult = "";

        jsonResponse.adpods.forEach(adpod => {
          adpod.targeting.forEach(targeting => {
            for(const targetingKey in targeting) {
              parsingResult += `${targetingKey}=${targeting[targetingKey]}&`;
            }
          });
        });


        parsingResult = parsingResult.replace(/&$/, "");

        if(custParams) {
          custParams = custParams + "&" + parsingResult;
        }
        else {
          custParams = parsingResult;
        }

        appendedTag = URLUtils.addQueryParam(tag, "cust_params", encodeURIComponent(custParams));
      }
    }
    catch (e) {
    }

    return appendedTag;
  }
}
